import script from "./BaseDisclaimer.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseDisclaimer.vue?vue&type=script&setup=true&lang=js"

import "./BaseDisclaimer.vue?vue&type=style&index=0&id=5a217304&lang=scss"

const __exports__ = script;

export default __exports__